// AI Generated
import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { Transition, TransitionService } from '@uirouter/core';
import { MonBrowserService } from '@monsido/services/mon-browser/mon-browser.service';
import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';

@Component({
    selector: 'base-layout',
    standalone: false,
    styleUrls: ['./base.component.css'],
    template: `
    <div class="base-layout-container">
        <a href="#maincontent"
            class="skip-to-content shell-hidden-print">
            <span translate>Skip to content</span>
        </a>
        <mon-top-navigation />
            @if (submenu === 'policy') {
                <div class="submenu-wrapper">
                    <submenu-policy />
                </div>
            }
        <div
            id="page-content"
            class="page-content"
            [attr.data-ui-shell]="uiShell"
        >
            <div *ngIf="showSideNavigation" id="sidebar-container" class="shell-hidden-print">
                <mon-side-navigation-container />
                <!-- <div id="sidebar">
                    @switch (menu) {
                        @case ('accessibility') {
                            <side-menu-accessibility />
                        }
                        @case ('admin') {
                            <side-menu-admin />
                        }
                        @case ('data-privacy') {
                            <side-menu-data-privacy />
                        }
                        @case ('compliance-shield') {
                            <side-menu-compliance-shield />
                        }
                        @case ('inventory') {
                            <side-menu-inventory />
                        }
                        @case ('policy') {
                            <side-menu-policy />
                        }
                        @case ('quality') {
                            <side-menu-quality />
                        }
                        @case ('seo') {
                            <side-menu-seo />
                        }
                        @case ('statistics') {
                            <side-menu-statistics />
                        }
                    }
                </div> -->
            </div>
            <main id="maincontent"
                  [ngClass]="{'legacy-shell': uiShell === 'legacy', 'modern-shell': uiShell === 'modern', 'with-side-navigation': showSideNavigation}"
                  role="main"
                  tabindex="-1"
                  class="shell-main-container">
                <div data-legacy-content-scope
                        [attr.data-uses-modern-styles]="usesModernStyles ? 'true' : 'false'">
                    <ui-view></ui-view>
                    <ui-view *ngIf="homeState" name="home"></ui-view>
                    <ui-view name="customer"></ui-view>
                </div>
            </main>
        </div>
        <mon-legacy-browser-notification
            *ngIf="hasIeLegacyNotification"
            [monMinimized]="ieLegacyNotificationMinimized"
            (monClose)="minimizeIeLegacyNotification()"
            (monOpen)="maximizeIeLegacyNotification()">
        </mon-legacy-browser-notification>
        <global-error-message />
        <!-- Global toast for new redesign ui -->
        <mon-global-toast-container />
    </div>
    `,
})
export class BaseLayoutComponent implements OnInit {
    activeMenuEntry: any;
    sidebar: any;
    withSidebar: boolean = false;
    menu: any;
    submenu: any;
    showSubMenu: boolean = false;
    hasIeLegacyNotification: boolean = false;
    ieLegacyNotificationMinimized: boolean = false;
    homeState = true;
    usesModernStyles = false;
    showSideNavigation = false;

    constructor (
        private stateService: StateService,
        private transitions: TransitionService,
        private monBrowserService: MonBrowserService,
        @Inject(DOCUMENT) private document: Document,
    ) {}

    get uiShell (): 'legacy' | 'modern' {
        return this.document.body.getAttribute('data-ui-shell') === 'modern' ? 'modern' : 'legacy';
    }

    ngOnInit (): void {
        // this.transitions.onExit({ exiting: (state) => !!state?.onExit }, () => {});

        this.showSideNavigation = this.isSideNavigationState(this.stateService.current?.name);

        const stateObj = this.stateService.current.data;
        this.handleSubMenu(stateObj);
        this.usesModernStyles = this.resolveUsesModernStyles(stateObj);

        this.transitions.onStart({}, (transition: Transition) => {
            const toState = transition.to();
            this.homeState = toState.name === 'base.dashboard';
            this.usesModernStyles = this.resolveUsesModernStyles(toState.data);
            this.showSideNavigation = this.isSideNavigationState(toState.name);
        });

        this.transitions.onSuccess({}, (transition: Transition) => {
            const toState = transition.to();
            this.handleSubMenu(toState.data);
            this.usesModernStyles = this.resolveUsesModernStyles(toState.data);
            this.showSideNavigation = this.isSideNavigationState(toState.name);
        });

        this.ieLegacyNotificationMinimized = false;
        if (this.monBrowserService.isIe11() || this.monBrowserService.isEdgeLegacy()) {
            this.hasIeLegacyNotification = true;
        }
    }

    handleSubMenu (data: any): void {
        const stateData = data || {};
        this.activeMenuEntry = stateData.activeSidebarEntry;
        this.sidebar = stateData.sidebar;
        this.withSidebar = stateData.sidebar !== undefined;
        this.menu = stateData.sidebar;
        this.submenu = stateData.topmenu;
        this.showSubMenu = stateData.topmenu !== undefined;
    }

    private resolveUsesModernStyles (data: any): boolean {
        return data?.usesModernStyles === true;
    }

    private isSideNavigationState (stateName?: string): boolean {
        if (!stateName) {
            return false;
        }

        return stateName === 'base.customer.domain' ||
            stateName.startsWith('base.customer.domain.') ||
            stateName === 'base.customer.admin' ||
            stateName.startsWith('base.customer.admin.');
    }

    goToMainContent (): void {
        const mainContent = document.getElementById('redesignmaincontent') || document.getElementById('maincontent');
        if (mainContent) {
            mainContent.scrollIntoView();
            mainContent.focus();
        }
    }

    minimizeIeLegacyNotification (): void {
        this.ieLegacyNotificationMinimized = true;
    }

    maximizeIeLegacyNotification (): void {
        this.ieLegacyNotificationMinimized = false;
    }
}
